import { useState } from "react";
import { validateAndSubmitForms } from "../api/services/validateAndSubmit.Forms";
import FileSaver from "file-saver";
import { message } from "antd";
const useForm = (selectedRecord) => {
  const [values, setValues] = useState({});

  const handleDropdown = ({ target }) => {
    const { value } = target;
  };

  const handleInputChange = ({ target }) => {
    const { name, value } = target;

    setValues({ ...values, [name]: value });
  };

  const handleDateChange = (date, dateString, group) => {
    const { id } = group;
    if (!date) {
      setValues({ ...values, [id]: "" });
      return;
    }
    setValues({ ...values, [id]: dateString });
  };

  const handleSingleFileUpload = (file, id) => {
    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;

    if (file.file.size && !isFileLt10MB) {
      message.error("Nije dopušteno učitavanje datoteka većih od 10MB.");
      return;
    }

    let fileList = [...file.fileList];

    fileList = fileList.slice(-1);

    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.name;
      }
      return file;
    });

    setValues({ ...values, [id]: fileList });
  };

  const handleMultiFileUpload = (file, id) => {
    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;

    if (file.file.size && !isFileLt10MB) {
      message.error("Nije dopušteno učitavanje datoteka većih od 10MB.");
      return;
    }

    let fileList = [...file.fileList];

    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.name;
      }
      return file;
    });

    setValues({ ...values, [id]: fileList });
  };

  const handleRadioButton =
    (id) =>
    ({ target }) => {
      const { value } = target;
      setValues({ ...values, [id]: value });
    };

  const handleNumberInput = (e) => {
    const { value, name } = e.target;
    const parsedValue = value.replace(/\D/g, "");
    setValues({ ...values, [name]: parsedValue });
  };

  const handleDecimalNumberInput = (e) => {
    const { value, name } = e.target;
    const parsedValue = value.replace(/[^\d,]/g, "");
    setValues({ ...values, [name]: parsedValue });
  };

  const handleSubmit = (e) => {
    validateAndSubmitForms(selectedRecord, values, setValues);
  };

  const downloadAttachments = (group, type, fileName, idPredPolja) => (e) => {
    e.preventDefault();
    const valuesObj = values[group].find(
      (element) => element.idPredPolja == idPredPolja
    );

    if (valuesObj) {
      let binaryString = window.atob(valuesObj.fileContents);
      let binaryLen = binaryString.length;
      let bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      let blob = new Blob([bytes], {
        type,
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        FileSaver.saveAs(blob, fileName);
      }
    }
  };

  const removeAttachment = (group, id) => (e) => {
    setValues({
      ...values,
      [group]: values[group].filter((element) => element.idPredPolja != id),
      obrisaniDokumenti: [...values.obrisaniDokumenti, id],
    });
  };

  return {
    values,
    setValues,
    handleInputChange,
    handleDropdown,
    handleDateChange,
    handleSingleFileUpload,
    handleSubmit,
    handleRadioButton,
    handleNumberInput,
    handleDecimalNumberInput,
    downloadAttachments,
    removeAttachment,
    handleMultiFileUpload,
  };
};

export default useForm;
